import { AlarmCentralCompany, AlarmCentralModels } from './enums';

export interface IAlarmCentralModelOption {
  label: string;
  value?: AlarmCentralModels;
  parentValue?: AlarmCentralCompany;
  children?: IAlarmCentralModelOption[];
}
export interface IAlarmCentralCompanyOption {
  label: string;
  value: AlarmCentralCompany;
}

export const getAlarmCentralModelOptions: IAlarmCentralModelOption[] = [
  {
    label: 'Intelbras',
    parentValue: AlarmCentralCompany.INTELBRAS,
    children: [
      { label: 'AMT 4010', value: AlarmCentralModels.AMT4010 },
      { label: 'AMT 2018 E/EG', value: AlarmCentralModels.AMT2018EEG },
      { label: 'AMT 1016 NET', value: AlarmCentralModels.AMT1016NET },
      { label: 'AMT 2110', value: AlarmCentralModels.AMT2110 },
      { label: 'AMT 2118 EG', value: AlarmCentralModels.AMT2118EG },
      { label: 'ANM 24 NET', value: AlarmCentralModels.ANM24NET },
      { label: 'AMT 2018 E3G', value: AlarmCentralModels.AMT2018E3G },
      { label: 'AMT 2018 E Smart', value: AlarmCentralModels.AMT2018ESMART },
      { label: 'ELC 3020 NET', value: AlarmCentralModels.ELC3020NET },
      { label: 'AMT 8000', value: AlarmCentralModels.AMT8000 },
      { label: 'AMT 8000 PRO', value: AlarmCentralModels.AMT8000PRO },
      { label: 'AMT 8000 Lite', value: AlarmCentralModels.AMT8000LITE },
      { label: 'GPRS 1000 UN', value: AlarmCentralModels.GPRS1000UN },
      { label: 'AMT 1000 Smart', value: AlarmCentralModels.AMT1000SMART },
    ],
  },
  {
    label: 'Jfl',
    parentValue: AlarmCentralCompany.JFL,
    children: [
      { label: 'Active 8 Ultra', value: AlarmCentralModels.ACTIVE8ULTRA },
      { label: 'Active 20 Bus', value: AlarmCentralModels.ACTIVE20BUS },
      { label: 'Active 20 Ultra', value: AlarmCentralModels.ACTIVE20ULTRA },
      {
        label: 'Active 20 Ethernet',
        value: AlarmCentralModels.ACTIVE20ETHERNET,
      },
      { label: 'Active 20 GPRS', value: AlarmCentralModels.ACTIVE20GPRS },
      { label: 'Active 32 Duo', value: AlarmCentralModels.ACTIVE32DUO },
      { label: 'Active 100 Bus', value: AlarmCentralModels.ACTIVE100BUS },
      { label: 'Active Full 32', value: AlarmCentralModels.ACTIVEFULL32 },
      { label: 'Active 20', value: AlarmCentralModels.ACTIVE20 },
      { label: 'Active 8W', value: AlarmCentralModels.ACTIVE8W },
      { label: 'M-300 +', value: AlarmCentralModels.M300 },
      { label: 'M-300 Flex', value: AlarmCentralModels.M300FLEX },
    ],
  },
  {
    label: 'VETTI',
    parentValue: AlarmCentralCompany.VETTI,
    children: [
      { label: 'Smart Alarm M', value: AlarmCentralModels.SMARTALARMM },
      { label: 'Smart Alarm ME', value: AlarmCentralModels.SMARTALARMME },
      {
        label: 'Smart Alarm Monitorada',
        value: AlarmCentralModels.SMARTALARMMONITORADA,
      },
    ],
  },
  {
    label: 'PARADOX',
    parentValue: AlarmCentralCompany.PARADOX,
    children: [
      {
        label: 'EVO 58',
        value: AlarmCentralModels.EVO48,
      },
      {
        label: 'EVO 192',
        value: AlarmCentralModels.EVO192,
      },
      {
        label: 'EVO HD',
        value: AlarmCentralModels.EVOHD,
      },
      {
        label: 'MG 5000',
        value: AlarmCentralModels.MG5000,
      },
      {
        label: 'MG 5050',
        value: AlarmCentralModels.MG5050,
      },
      {
        label: 'Espectra 1728',
        value: AlarmCentralModels.ESPECTRA1728,
      },
      {
        label: 'Espectra 1738',
        value: AlarmCentralModels.ESPECTRA1738,
      },
      {
        label: 'Espectra 1832',
        value: AlarmCentralModels.ESPECTRA1832,
      },
      {
        label: 'Espectra 1864',
        value: AlarmCentralModels.ESPECTRA1864,
      },
      {
        label: 'SP 4000',
        value: AlarmCentralModels.SP4000,
      },
      {
        label: 'SP 5500',
        value: AlarmCentralModels.SP5500,
      },
      {
        label: 'SP 6000',
        value: AlarmCentralModels.SP6000,
      },
      {
        label: 'SP 7000',
        value: AlarmCentralModels.SP7000,
      },
    ],
  },
];

export const getAlarmCentralCompanyOptions: IAlarmCentralCompanyOption[] = [
  { label: 'Intelbras', value: AlarmCentralCompany.INTELBRAS },
  { label: 'Jfl', value: AlarmCentralCompany.JFL },
  { label: 'Vetti', value: AlarmCentralCompany.VETTI },
  { label: 'Paradox', value: AlarmCentralCompany.PARADOX },
];

export const getAlarmCentralModelName = (model: AlarmCentralModels) => {
  switch (model) {
    case AlarmCentralModels.AMT4010:
      return 'AMT 4010';
    // case 1:
    //   return 'AMT 2018 E/EG';
    // case 2:
    //   return 'AMT 1016 NET';
    // case 3:
    //   return 'AMT 2110';
    // case 4:
    //   return 'AMT 2118 EG';
    // case 5:
    //   return 'ANM 24 NET';
    // case 6:
    //   return 'AMT 2018 E3G';
    // case 7:
    //   return 'AMT 2018 E Smart';
    // case 8:
    //   return 'ELC 3020 NET';
    // case 9:
    //   return 'AMT 8000';
    // case 10:
    //   return 'AMT 8000 PRO';
    // case 11:
    //   return 'AMT 8000 Lite';
    // case 12:
    //   return 'GPRS 1000 UN';
    // case 13:
    //   return 'AMT 1000 Smart';
    // case 14:
    //   return 'Active 8 Ultra';
    // case 15:
    //   return 'Active 20 Bus';
    // case 16:
    //   return 'Active 20 Ultra';
    // case 17:
    //   return 'Active 20 Ethernet';
    // case 18:
    //   return 'Active 20 GPRS';
    // case 19:
    //   return 'Active 32 Duo';
    // case 20:
    //   return 'Active 100 Bus';
    // case 21:
    //   return 'Active Full 32';
    // case 22:
    //   return 'Active 20';
    // case 23:
    //   return 'Active 8W';
    // case 24:
    //   return 'M-300 +';
    // case 25:
    //   return 'M-300 Flex';
    // case 26:
    //   return 'Smart Alarm M';
    // case 27:
    //   return 'Smart Alarm ME';
    // case 28:
    //   return 'Smart Alarm Monitorada';
    default:
      return 'Modelo desconhecido';
  }
};
